import LoggerService from "./LoggerService";

import { RequestManager } from "./RequestManager";
import Utils from "./utils/Utils";
import { CONNECTION_STATES } from "./enums/LiveStreamingEnums";

export default class ConnectionManager {
  static connectionStatus = {};
  static currentUserConnectionStatus = CONNECTION_STATES.Connected;

  static async currentUserReconnected() {
    ConnectionManager.currentUserConnectionStatus = CONNECTION_STATES.Connected;
    LoggerService.info(
      LoggerService.MODULE.STREAMING,
      `[PROCTOR] [CONNECTED]`
    );
  }

  static async currentUserDisconnected() {
    ConnectionManager.currentUserConnectionStatus = CONNECTION_STATES.Disconnected;

    LoggerService.info(
      LoggerService.MODULE.STREAMING,
      `[PROCTOR] [DISCONNECTED]`
    );
  }

  static async remoteUserReconnected(peerId) {
    ConnectionManager.connectionStatus[peerId] = CONNECTION_STATES.Connected;

    // add new request
    const { userId, requestedStreams } = Utils.getDataFromPeerId(peerId);

    const config = {
      userId,
      requestedStreams
    };

    await RequestManager.createNewRequest(config);
  }

  static async remoteUserDisconnected(peerId) {
    ConnectionManager.connectionStatus[peerId] = CONNECTION_STATES.Disconnected;

    const { userId, requestedStreams } = Utils.getDataFromPeerId(peerId);

    const config = {
      userId,
      requestedStreams
    };

    await RequestManager.closeRequest(config);
  }

  static isCurrentUserConnected() {
    return ConnectionManager.currentUserConnectionStatus == CONNECTION_STATES.Connected;
  }

  static isRemoteUserConnected(peerId) {
    return ConnectionManager.connectionStatus[peerId] == CONNECTION_STATES.Connected;
  }
}
